import Invoice from './Invoice';

export default Invoice;
